export const SHOW_LOADER = "SHOW_LOADER";

export const ADD_NOTE = "ADD_NOTE";
export const FETCH_NOTES = "FETCH_NOTES";
export const TOGGLE_NOTE = "TOGGLE_NOTE";
export const REMOVE_NOTE = "REMOVE_NOTE";

export const SET_USER = "SET_USER";
export const REMOVE_USER = "REMOVE_USER";

export const FETCH_BOARDS = "FETCH_BOARDS";

export const FETCH_BOARD = "FETCH_BOARD";
export const ADD_BOARD = "ADD_BOARD";
export const DELETE_BOARD = "DELETE_BOARD";

export const ADD_LIST = "ADD_LIST";
export const DELETE_LIST = "DELETE_LIST";

export const ADD_CARD = "ADD_CARD";
export const DELETE_CARD = "DELETE_CARD";
